import type { ReactNode } from "react";
import classNames from "classnames";
import { useExpandableBlockData } from "./ExpandableBlockDataProvider";

export interface PanelProps {
  children: ReactNode;
  className?: string;
}

export const Panel = ({ className, children }: PanelProps) => {
  const { isOpen } = useExpandableBlockData();

  return (
    <div
      className={classNames(
        "transition-all duration-150 ease-in",
        {
          "max-h-0 opacity-0": !isOpen,
          "max-h-full opacity-100": isOpen,
        },
        className,
      )}
    >
      <div className="p-8 pt-0">{children}</div>
    </div>
  );
};
